import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';

import { Tooltip } from 'ui-components/components/tooltip';
import { testId } from 'ui-components/services/testid-service';

import { CustomsField } from '../customs-field';
import { CustomsTextInput } from '../customs-text-input';
import { messages } from '../messages';
import commonStyle from '../common-style.module.less';

type CustomsSkuProps = {
  value?: string;
  onChange: (value: string | number) => void;
  shouldShowEuPidHints?: boolean;
};

export const CustomsSku: React.FC<CustomsSkuProps> = ({ onChange, value = '', shouldShowEuPidHints = false }) => {
  const intl = useIntl();

  const tooltip = shouldShowEuPidHints ? (
    <Tooltip position='top' text={intl.formatMessage(messages.skuEuTooltip)}>
      <FontAwesomeIcon icon={faInfoCircle} />
    </Tooltip>
  ) : undefined;

  return (
    <CustomsField
      label={messages.skuLabel}
      labelClassname={shouldShowEuPidHints ? commonStyle['label-with-tooltip'] : undefined}
      recommended={shouldShowEuPidHints}
      tooltip={tooltip}
    >
      <CustomsTextInput
        aria-label={intl.formatMessage(messages.skuLabel)}
        {...testId('customs-widget-sku-input')}
        onChange={onChange}
        type='text'
        value={value}
      />
    </CustomsField>
  );
};
